import { useGetApiV1SerievideoVideoidLangs } from '@/shared/api/generated';

/** Itens por página da listagem de Idiomas do Vídeo (paginação server-side). */
export const SERIE_VIDEO_LANG_PAGE_SIZE = 20;

/**
 * Hook para listar os Idiomas de um Vídeo, com paginação **server-side**.
 *
 * Envolve o hook gerado pelo Kubb para `GET /api/v1/serievideo/{videoId}/langs`.
 *
 * @param videoId - ID do vídeo
 * @param serieId - ID da série (só para o parâmetro de query, não afeta o filtro)
 * @param page - Página atual (1-indexed)
 *
 * @example
 * ```tsx
 * const { langs, totalCount, isLoading } = useSerieVideoLangList(videoId, serieId, page);
 * ```
 */
export function useSerieVideoLangList(videoId: number, serieId: number, page: number) {
  const query = useGetApiV1SerievideoVideoidLangs(videoId, {
    serieId,
    page,
    pageSize: SERIE_VIDEO_LANG_PAGE_SIZE,
  });

  return {
    langs: query.data?.data ?? [],
    totalCount: query.data?.totalCount ?? 0,
    totalPages: query.data?.totalPages ?? 1,
    currentPage: query.data?.currentPage ?? page,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  } as const;
}
